import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['input', 'link', 'submit']
  
  sort(event) {
    event.preventDefault()
    const orderBy = event.target.dataset.sortableOrder
    let order = ' desc'
    
    if (this.currentSortOrder == `${orderBy} desc`) {
      order = ' asc'
    } else {
      order = ' desc'
    }
    
    this.inputTarget.value = orderBy + order
    this.submitTarget.click()
  }
  
  
  get currentSortOrder() {
    return this.inputTarget.value.toLowerCase()
  }
}